// Angular modules
import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-layout',
  standalone: false,
  templateUrl: './page-layout.component.html',
  styleUrls: ['./page-layout.component.scss']
})
export class PageLayoutComponent implements OnInit {
  public propertyUrlSegment!: string;
  constructor(private router: Router) {

  }

  public ngOnInit(): void {
    const currentUrl = this.router.url;
    const accountIndex = currentUrl.indexOf('/account');
    const propertyIndex = currentUrl.indexOf('/property');
    const managementIndex = currentUrl.indexOf('/management');
    const walletIndex = currentUrl.indexOf('/wallet');

    if (accountIndex !== -1) {
      this.propertyUrlSegment = currentUrl.substring(0, accountIndex + 8); // Add 8 to include "/account"
    }


    else if (propertyIndex !== -1) {
      this.propertyUrlSegment = currentUrl.substring(0, propertyIndex + 9); // Add 11 to include "/property"
    }

    else if (managementIndex !== -1) {
      this.propertyUrlSegment = currentUrl.substring(0, managementIndex + 11); // Add 11 to include "/management"
    }
    else if (walletIndex !== -1) {
      this.propertyUrlSegment = currentUrl.substring(0, walletIndex + 7); // Add 11 to include "/wallet"
    }

    else {
      this.propertyUrlSegment = ''; // or handle error
    }
  }

  // -------------------------------------------------------------------------------
  // NOTE Init ---------------------------------------------------------------------
  // -------------------------------------------------------------------------------

  // -------------------------------------------------------------------------------
  // NOTE Actions ------------------------------------------------------------------
  // -------------------------------------------------------------------------------

  // -------------------------------------------------------------------------------
  // NOTE Computed props -----------------------------------------------------------
  // -------------------------------------------------------------------------------

  // -------------------------------------------------------------------------------
  // NOTE Helpers ------------------------------------------------------------------
  // -------------------------------------------------------------------------------

  // -------------------------------------------------------------------------------
  // NOTE Requests -----------------------------------------------------------------
  // -------------------------------------------------------------------------------

  // -------------------------------------------------------------------------------
  // NOTE Subscriptions ------------------------------------------------------------
  // -------------------------------------------------------------------------------

}
